import styled from "styled-components";

export const MobileProfileStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    .negative {
        color: var(--color-red);
    }
`;

export const MobileProfileNotificationIconContainerStyled = styled.div`
    font-size: 38px;
`;
